import { Link } from "react-router-dom";

import { PageContainer } from "@/components/core/page-container";
import { Seo } from "@/components/seo/seo";
import { buttonVariants } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useLocale } from "@/i18n/locale-context";

export function NotFoundPage(): JSX.Element {
  const { locale, localePath, t } = useLocale();

  return (
    <>
      <Seo
        description={t("errors.notFoundIntro")}
        locale={locale}
        noindex
        pathWithoutLocale="/404"
        title={t("errors.notFoundSeoTitle")}
      />
      <section className="py-10 sm:py-12 md:py-16">
        <PageContainer>
          <Card className="mx-auto max-w-4xl space-y-5" variant="content">
            <p className="eyebrow">404</p>
            <h1 className="max-w-3xl text-[2.15rem] leading-[1.02] sm:text-4xl md:text-5xl">
              {t("errors.notFoundTitle")}
            </h1>
            <p className="max-w-2xl text-sm leading-7 text-muted-foreground sm:text-base">
              {t("errors.notFoundIntro")}
            </p>
            <div>
              <Link
                className={buttonVariants({ variant: "outline" })}
                to={localePath("/")}
              >
                {t("actions.backToHome")}
              </Link>
            </div>
          </Card>
        </PageContainer>
      </section>
    </>
  );
}
